// Colocated Driver.js tour for the Approvals page, targeted at anyone
// with review authority: super admins, accountants (for wallet top-ups
// once the permission is granted to them individually), and team
// reviewers. Four steps, no FAQ outro: by the time a viewer reaches
// Approvals they will have already seen the outro at the end of their
// first-login tour. Kept short: the tour lands the viewer on the
// filters and the row action, and lets them discover the Review
// modal's own inputs naturally when they click through.

export const APPROVALS_OVERVIEW_TOUR_ID = 'approvals-overview-v1';

export const buildApprovalsOverviewTourSteps = () => [
    {
        element: '[data-tour="approvals-card"]',
        title: 'Where your say counts',
        description: 'People on your team need your green light on two things: spending above their current limit for a specific reason, and topping up their wallet. Both land here for you or another authorised reviewer to decide.',
        side: 'bottom',
        align: 'center',
    },
    {
        element: '[data-tour="approvals-filters"]',
        title: 'Focus on what needs you now',
        description: 'Flip between Pending, Approved, and Rejected when you want the history. Filter by type to work through just limit extensions or just wallet top-ups. Pending is the default because that is where your action is needed.',
        side: 'bottom',
        align: 'start',
    },
    {
        element: '[data-tour="approvals-table"]',
        title: 'Everything you need to decide',
        description: 'Each row shows who asked, what they want to do, how much, and why. Team reviewers see only rows they are authorised to act on. Super admins see every row on the organisation.',
        side: 'top',
        align: 'center',
    },
    {
        element: '[data-tour="approvals-card"]',
        title: 'Make the call',
        description: 'Tap Review on any pending row and we will open a card with the full request and ask you to approve or reject. Rejections need a short reason so the requester knows what to fix; approvals may ask you for an expiry date on per-transaction extensions. Either way we email the requester the outcome.',
        side: 'top',
        align: 'center',
    },
    {
        element: '[data-tour="approvals-card"]',
        title: 'Approving a wallet top-up asks for your PIN',
        description: 'When you approve a wallet top-up request, we ask you to confirm your transaction PIN before the money moves. This keeps a stolen session from quietly signing off on a top-up in your name. Rejecting a request never asks for a PIN, because a rejection moves no money.',
        side: 'top',
        align: 'center',
    },
];
